import { useEffect } from 'react';

const About = () => {
  useEffect(() => {
    const ob = new IntersectionObserver(
      (entries) => {
        entries.forEach((e) => {
          if (e.isIntersecting) e.target.classList.add('is-visible');
        });
      },
      { threshold: 0.2 }
    );
    document.querySelectorAll('.reveal').forEach((el) => ob.observe(el));
    return () => ob.disconnect();
  }, []);

  const principles = [
    { icon: 'ri-check-double-line', title: '先核实再收录', desc: '每一条资源都经过人工试用与核对，剔除失效与劣质入口，保证真正能用。' },
    { icon: 'ri-tools-line', title: '按需分类整理', desc: '不搞关键词堆砌，而是按真实使用场景分类，让你一进来就找到对的位置。' },
    { icon: 'ri-refresh-line', title: '每周滚动更新', desc: '热门工具与资料合集持续增补，失效资源及时下架，让清单保持鲜活。' },
    { icon: 'ri-heart-line', title: '免费开放使用', desc: '收录以免费或可商用资源为主，导航不设门槛，收藏夹也不限数量。' },
  ];

  const praises = [
    { role: '设计师 · 小林', text: '找免版权素材和配色灵感以前要开一堆网页，现在 51全网 一个目录就够，收藏夹攒了不少好东西。' },
    { role: '自由职业者 · 阿卓', text: '模板和格式转换工具集中在一起很省心，做简历、传文件都快了不少，基本每两周回来逛一次。' },
  ];

  return (
    <section id="about" aria-label="关于 51全网">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="grid grid-cols-1 gap-10 lg:grid-cols-2 lg:gap-14">
          {/* 品牌介绍 */}
          <div className="reveal rounded-xl border border-background-200 bg-background-50 p-6 md:p-8">
            <span className="inline-flex items-center gap-1.5 rounded-full bg-accent-100 px-3 py-1 text-xs font-semibold text-accent-800">
              <i className="ri-sparkling-line text-sm" aria-hidden="true" />
              关于 51全网
            </span>
            <h2 className="mt-4 font-heading text-2xl font-bold leading-snug text-foreground-950 md:text-3xl">
              把散落各处的优质资源，
              <span className="text-primary-600">收进一张好用的清单</span>
            </h2>
            <p className="mt-4 text-sm leading-7 text-foreground-700">
              51全网 是一份持续维护的资源导航：我们把常用工具、模板文档、免版权素材、
              资料合集与实用网站，按使用场景分门别类地放在一起。
              你不用在收藏夹里翻找几百条杂乱链接，也不用为一个小需求来回切换多个站点，
              打开 51全网，按分类就能快速定位并保存真正用得上的资源。
            </p>
            <p className="mt-3 text-sm leading-7 text-foreground-700">
              从第一张分类清单开始，我们坚持“少而精、真可用”的收录标准——
              每一个入口都人工核实，每一条描述都如实，让导航回归“帮你更快找到”的初心。
            </p>
            <dl className="mt-6 grid grid-cols-3 gap-3">
              {[
                ['8', '常设分类'],
                ['48+', '在录资源'],
                ['每周', '滚动更新'],
              ].map(([n, l]) => (
                <div key={l} className="rounded-lg bg-background-100 px-3 py-4 text-center">
                  <dd className="font-heading text-2xl font-black text-primary-600">{n}</dd>
                  <dt className="mt-1 text-xs text-foreground-600">{l}</dt>
                </div>
              ))}
            </dl>
          </div>

          {/* 内容原则 */}
          <div>
            <div className="flex items-center gap-2">
              <span className="flex h-8 w-8 items-center justify-center rounded-md bg-secondary-500 text-background-50">
                <i className="ri-flag-2-line text-lg" aria-hidden="true" />
              </span>
              <h2 className="font-heading text-xl font-bold text-foreground-950 md:text-2xl">我们的内容原则</h2>
            </div>
            <div className="mt-5 grid grid-cols-1 gap-3 sm:grid-cols-2">
              {principles.map((p) => (
                <div key={p.title} className="rounded-lg border border-background-200 bg-background-50 p-4">
                  <span className="flex h-9 w-9 items-center justify-center rounded-md bg-primary-100 text-primary-700">
                    <i className={`${p.icon} text-lg`} aria-hidden="true" />
                  </span>
                  <h3 className="mt-3 text-sm font-bold text-foreground-950">{p.title}</h3>
                  <p className="mt-1.5 text-xs leading-5 text-foreground-700">{p.desc}</p>
                </div>
              ))}
            </div>

            {/* 口碑 */}
            <div className="mt-4 rounded-lg border border-accent-200 bg-accent-50 p-4">
              <p className="text-xs font-semibold uppercase tracking-wide text-accent-800">大家这样说</p>
              <div className="mt-3 space-y-3">
                {praises.map((pr) => (
                  <figure key={pr.role}>
                    <p className="text-xs italic leading-6 text-accent-900">“{pr.text}”</p>
                    <figcaption className="mt-1 text-[11px] font-semibold text-accent-700">{pr.role}</figcaption>
                  </figure>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;